import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Tenant } from '../contracts/tenant.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private baseUrl = 'tenants/';

  constructor(private http: HttpClient) {}

  getAll(): Observable<Tenant[]> {
    return this.http.get<Tenant[]>(this.baseUrl);
  }

  getById(id: number): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.baseUrl}${id}`);
  }

  create(tenant: Tenant): Observable<Tenant> {
    return this.http.post<Tenant>(this.baseUrl, tenant);
  }

  update(id: number, tenant: Tenant): Observable<Tenant> {
    return this.http.put<Tenant>(`${this.baseUrl}${id}`, tenant);
  }

  delete(id: number): Observable<Tenant> {
    return this.http.delete<Tenant>(`${this.baseUrl}${id}`);
  }

  upload(id: number, formData: any): Observable<any> {
    return this.http.post<string>(`${this.baseUrl}${id}/logo`, formData);
  }

}
